import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-round-image',
    template: '<i class="fa-solid fa-user" [style.width.px]="width" [style.height.px]="height"></i>',
    imports: [CommonModule]
})
export class RoundImageComponent {
    @Input() url?: string;
    @Input() useDefaultMissingImage = false;
    @Input() width = 30;
    @Input() height = 30;
}
